module.exports = __webpack_public_path__ + "img/device03.c263bb78.png";